let data = {

	0:{
		meta:require("./projects/fabiantex malhas/meta.json"),
		images:{
				0:require("./projects/fabiantex malhas/small/DJI_0579.JPG"),
				1:require("./projects/fabiantex malhas/small/DJI_0597.JPG"),
				2:require("./projects/fabiantex malhas/small/DJI_0606.JPG"),
				3:require("./projects/fabiantex malhas/small/DJI_0593.JPG"),
				4:require("./projects/fabiantex malhas/small/DJI_0603.JPG"),
				5:require("./projects/fabiantex malhas/small/DJI_0586.JPG"),
				6:require("./projects/fabiantex malhas/small/DJI_0611.JPG"),
				7:require("./projects/fabiantex malhas/small/DJI_0610.JPG"),
				8:require("./projects/fabiantex malhas/small/DJI_0612.JPG"),
				9:require("./projects/fabiantex malhas/small/DJI_0613.JPG"),
				10:require("./projects/fabiantex malhas/small/DJI_0582.JPG"),
				11:require("./projects/fabiantex malhas/small/DJI_0617.JPG"),
				12:require("./projects/fabiantex malhas/small/DJI_0581.JPG"),
				13:require("./projects/fabiantex malhas/small/DJI_0616.JPG"),
				14:require("./projects/fabiantex malhas/small/DJI_0601.JPG"),
				15:require("./projects/fabiantex malhas/small/DJI_0594.JPG"),
				16:require("./projects/fabiantex malhas/small/DJI_0587.JPG"),
				17:require("./projects/fabiantex malhas/small/DJI_0583.JPG"),
}
},
	1:{
		meta:require("./projects/sebastiao ramos/meta.json"),
		images:{
				0:require("./projects/sebastiao ramos/small/DJI_0198.JPG"),
				1:require("./projects/sebastiao ramos/small/DJI_0202.JPG"),
				2:require("./projects/sebastiao ramos/small/DJI_0195.JPG"),
}
},
	2:{
		meta:require("./projects/diedro/meta.json"),
		images:{
				0:require("./projects/diedro/small/DJI_0693.JPG"),
				1:require("./projects/diedro/small/DJI_0699.JPG"),
				2:require("./projects/diedro/small/DJI_0683.JPG"),
}
},
	3:{
		meta:require("./projects/leonardo/meta.json"),
		images:{
				0:require("./projects/leonardo/small/2020030414055961.jpg"),
				1:require("./projects/leonardo/small/2020030414091010.jpg"),
				2:require("./projects/leonardo/small/2020030414071920.jpg"),
}
},
	4:{
		meta:require("./projects/leyser/meta.json"),
		images:{
				0:require("./projects/leyser/small/2020051515160026.jpg"),
				1:require("./projects/leyser/small/2020051515164288.jpg"),
}
},
	5:{
		meta:require("./projects/ipanema alimentos/meta.json"),
		images:{
				0:require("./projects/ipanema alimentos/small/DJI_0035.JPG"),
				1:require("./projects/ipanema alimentos/small/DJI_0042.JPG"),
				2:require("./projects/ipanema alimentos/small/DJI_0039.JPG"),
				3:require("./projects/ipanema alimentos/small/DJI_0036.JPG"),
				4:require("./projects/ipanema alimentos/small/DJI_0034.JPG"),
				5:require("./projects/ipanema alimentos/small/DJI_0038.JPG"),
				6:require("./projects/ipanema alimentos/small/DJI_0047.JPG"),
				7:require("./projects/ipanema alimentos/small/DJI_0045.JPG"),
				8:require("./projects/ipanema alimentos/small/DJI_0033.JPG"),
				9:require("./projects/ipanema alimentos/small/DJI_0040.JPG"),
				10:require("./projects/ipanema alimentos/small/DJI_0029.JPG"),
				11:require("./projects/ipanema alimentos/small/DJI_0037.JPG"),
				12:require("./projects/ipanema alimentos/small/DJI_0041.JPG"),
				13:require("./projects/ipanema alimentos/small/DJI_0030.JPG"),
				14:require("./projects/ipanema alimentos/small/DJI_0044.JPG"),
				15:require("./projects/ipanema alimentos/small/DJI_0032.JPG"),
				16:require("./projects/ipanema alimentos/small/DJI_0046.JPG"),
				17:require("./projects/ipanema alimentos/small/DJI_0028.JPG"),
				18:require("./projects/ipanema alimentos/small/DJI_0043.JPG"),
				19:require("./projects/ipanema alimentos/small/DJI_0031.JPG"),
}
},
	6:{
		meta:require("./projects/zuppani/meta.json"),
		images:{
				0:require("./projects/zuppani/small/2021032515002268.jpg"),
				1:require("./projects/zuppani/small/2021032514592847.jpg"),
				2:require("./projects/zuppani/small/2021032515010916.jpg"),
}
},
	7:{
		meta:require("./projects/lazaro/meta.json"),
		images:{
				0:require("./projects/lazaro/small/2020070413003267.jpg"),
				1:require("./projects/lazaro/small/2020070412584779.jpg"),
				2:require("./projects/lazaro/small/2020070412593127.jpg"),
}
},
	8:{
		meta:require("./projects/alexandre/meta.json"),
		images:{
				0:require("./projects/alexandre/small/2021021113414469.jpg"),
				1:require("./projects/alexandre/small/2021021113433162.jpg"),
				2:require("./projects/alexandre/small/2021021113401937.jpg"),
}
},
	10:{
		meta:require("./projects/paulo/meta.json"),
		images:{
				0:require("./projects/paulo/small/DJI_0364.JPG"),
				1:require("./projects/paulo/small/DJI_0362.JPG"),
				2:require("./projects/paulo/small/DJI_0379.JPG"),
				3:require("./projects/paulo/small/DJI_0378.JPG"),
				4:require("./projects/paulo/small/DJI_0373.JPG"),
}
},
	11:{
		meta:require("./projects/delio/meta.json"),
		images:{
				0:require("./projects/delio/small/DJI_0354.jpg"),
				1:require("./projects/delio/small/DJI_0342.jpg"),
				2:require("./projects/delio/small/DJI_0358.jpg"),
				3:require("./projects/delio/small/DJI_0349.jpg"),
				4:require("./projects/delio/small/DJI_0350.jpg"),
				5:require("./projects/delio/small/DJI_0351.jpg"),
				6:require("./projects/delio/small/DJI_0355.jpg"),
				7:require("./projects/delio/small/DJI_0345.jpg"),
				8:require("./projects/delio/small/DJI_0356.jpg"),
				9:require("./projects/delio/small/DJI_0346.jpg"),
				10:require("./projects/delio/small/DJI_0352.jpg"),
				11:require("./projects/delio/small/DJI_0348.jpg"),
				12:require("./projects/delio/small/DJI_0347.jpg"),
				13:require("./projects/delio/small/DJI_0344.jpg"),
				14:require("./projects/delio/small/DJI_0343.jpg"),
				15:require("./projects/delio/small/DJI_0357.jpg"),
				16:require("./projects/delio/small/DJI_0353.jpg"),
}
},
	12:{
		meta:require("./projects/rogerio/meta.json"),
		images:{
				0:require("./projects/rogerio/small/2020012116242732.jpg"),
				1:require("./projects/rogerio/small/2020012116255883.jpg"),
				2:require("./projects/rogerio/small/2020012116261206.jpg"),
}
},
	13:{
		meta:require("./projects/luciano/meta.json"),
		images:{
				0:require("./projects/luciano/small/2020020410415297.jpg"),
				1:require("./projects/luciano/small/2020020410473250.jpg"),
				2:require("./projects/luciano/small/2020020410443745.jpg"),
}
},
	15:{
		meta:require("./projects/walter/meta.json"),
		images:{
				0:require("./projects/walter/small/2020112017021268.jpg"),
				1:require("./projects/walter/small/2020120812400827.jpg"),
				2:require("./projects/walter/small/2020112017032458.jpg"),
}
},
	16:{
		meta:require("./projects/orionalda/meta.json"),
		images:{
				0:require("./projects/orionalda/small/DJI_0318.jpg"),
				1:require("./projects/orionalda/small/DJI_0339.jpg"),
				2:require("./projects/orionalda/small/DJI_0331.jpg"),
				3:require("./projects/orionalda/small/DJI_0308.jpg"),
				4:require("./projects/orionalda/small/DJI_0321.jpg"),
				5:require("./projects/orionalda/small/DJI_0322.jpg"),
				6:require("./projects/orionalda/small/DJI_0309.jpg"),
				7:require("./projects/orionalda/small/DJI_0313.jpg"),
				8:require("./projects/orionalda/small/DJI_0330.jpg"),
				9:require("./projects/orionalda/small/DJI_0336.jpg"),
				10:require("./projects/orionalda/small/DJI_0325.jpg"),
				11:require("./projects/orionalda/small/DJI_0317.jpg"),
				12:require("./projects/orionalda/small/DJI_0310.jpg"),
				13:require("./projects/orionalda/small/DJI_0315.jpg"),
				14:require("./projects/orionalda/small/DJI_0341.jpg"),
				15:require("./projects/orionalda/small/DJI_0334.jpg"),
				16:require("./projects/orionalda/small/DJI_0319.jpg"),
				17:require("./projects/orionalda/small/DJI_0340.jpg"),
				18:require("./projects/orionalda/small/DJI_0338.jpg"),
				19:require("./projects/orionalda/small/DJI_0333.jpg"),
				20:require("./projects/orionalda/small/DJI_0327.jpg"),
				21:require("./projects/orionalda/small/DJI_0312.jpg"),
				22:require("./projects/orionalda/small/DJI_0316.jpg"),
				23:require("./projects/orionalda/small/DJI_0324.jpg"),
				24:require("./projects/orionalda/small/DJI_0335.jpg"),
				25:require("./projects/orionalda/small/DJI_0323.jpg"),
				26:require("./projects/orionalda/small/DJI_0311.jpg"),
				27:require("./projects/orionalda/small/DJI_0329.jpg"),
				28:require("./projects/orionalda/small/DJI_0314.jpg"),
				29:require("./projects/orionalda/small/DJI_0320.jpg"),
				30:require("./projects/orionalda/small/DJI_0328.jpg"),
				31:require("./projects/orionalda/small/DJI_0326.jpg"),
				32:require("./projects/orionalda/small/DJI_0332.jpg"),
				33:require("./projects/orionalda/small/DJI_0337.jpg"),
}
},
	17:{
		meta:require("./projects/nelio santana/meta.json"),
		images:{
				0:require("./projects/nelio santana/small/2021031817350733.jpg"),
				1:require("./projects/nelio santana/small/2021031817355561.jpg"),
				2:require("./projects/nelio santana/small/2021031817361979.jpg"),
}
},
	18:{
		meta:require("./projects/claudio/meta.json"),
		images:{
				0:require("./projects/claudio/small/23122020-2020122315140607.jpg"),
				1:require("./projects/claudio/small/2020122315151435.jpg"),
				2:require("./projects/claudio/small/2020122315144958.jpg"),
}
},
	19:{
		meta:require("./projects/atevaldo/meta.json"),
		images:{
				0:require("./projects/atevaldo/small/2020111212332453.jpg"),
				1:require("./projects/atevaldo/small/2020111212325576.jpg"),
				2:require("./projects/atevaldo/small/2020111212314888.jpg"),
}
},
	20:{
		meta:require("./projects/reiner peres/meta.json"),
		images:{
				0:require("./projects/reiner peres/small/2022033116461091.jpg"),
				1:require("./projects/reiner peres/small/2022033116462821.jpg"),
				2:require("./projects/reiner peres/small/2022033116452201.jpg"),
}
},
	21:{
		meta:require("./projects/eduardo craveiro/meta.json"),
		images:{
				0:require("./projects/eduardo craveiro/small/DJI_0271.JPG"),
				1:require("./projects/eduardo craveiro/small/DJI_0263.JPG"),
				2:require("./projects/eduardo craveiro/small/DJI_0266.JPG"),
}
},
	22:{
		meta:require("./projects/josiel/meta.json"),
		images:{
				0:require("./projects/josiel/small/DJI_0947.JPG"),
				1:require("./projects/josiel/small/DJI_0944.JPG"),
				2:require("./projects/josiel/small/DJI_0949.JPG"),
				3:require("./projects/josiel/small/DJI_0943.JPG"),
				4:require("./projects/josiel/small/DJI_0942.JPG"),
				5:require("./projects/josiel/small/DJI_0946.JPG"),
				6:require("./projects/josiel/small/DJI_0940.JPG"),
				7:require("./projects/josiel/small/DJI_0945.JPG"),
				8:require("./projects/josiel/small/DJI_0941.JPG"),
				9:require("./projects/josiel/small/DJI_0948.JPG"),
				10:require("./projects/josiel/small/DJI_0950.JPG"),
				11:require("./projects/josiel/small/DJI_0951.JPG"),
				12:require("./projects/josiel/small/DJI_0952.JPG"),
}
},
	24:{
		meta:require("./projects/atevaldo novo/meta.json"),
		images:{
				0:require("./projects/atevaldo novo/small/DJI_0083.JPG"),
				1:require("./projects/atevaldo novo/small/DJI_0051.JPG"),
				2:require("./projects/atevaldo novo/small/DJI_0090.JPG"),
				3:require("./projects/atevaldo novo/small/DJI_0071.JPG"),
				4:require("./projects/atevaldo novo/small/DJI_0068.JPG"),
				5:require("./projects/atevaldo novo/small/DJI_0061.JPG"),
				6:require("./projects/atevaldo novo/small/DJI_0077.JPG"),
				7:require("./projects/atevaldo novo/small/DJI_0085.JPG"),
				8:require("./projects/atevaldo novo/small/DJI_0091.JPG"),
				9:require("./projects/atevaldo novo/small/DJI_0074.JPG"),
				10:require("./projects/atevaldo novo/small/DJI_0062.JPG"),
				11:require("./projects/atevaldo novo/small/DJI_0065.JPG"),
				12:require("./projects/atevaldo novo/small/DJI_0092.JPG"),
				13:require("./projects/atevaldo novo/small/DJI_0089.JPG"),
				14:require("./projects/atevaldo novo/small/DJI_0063.JPG"),
				15:require("./projects/atevaldo novo/small/DJI_0082.JPG"),
				16:require("./projects/atevaldo novo/small/DJI_0076.JPG"),
				17:require("./projects/atevaldo novo/small/DJI_0086.JPG"),
				18:require("./projects/atevaldo novo/small/DJI_0075.JPG"),
				19:require("./projects/atevaldo novo/small/DJI_0072.JPG"),
				20:require("./projects/atevaldo novo/small/DJI_0052.JPG"),
				21:require("./projects/atevaldo novo/small/DJI_0059.JPG"),
				22:require("./projects/atevaldo novo/small/DJI_0049.JPG"),
				23:require("./projects/atevaldo novo/small/DJI_0081.JPG"),
				24:require("./projects/atevaldo novo/small/DJI_0069.JPG"),
				25:require("./projects/atevaldo novo/small/DJI_0079.JPG"),
				26:require("./projects/atevaldo novo/small/DJI_0064.JPG"),
				27:require("./projects/atevaldo novo/small/DJI_0060.JPG"),
				28:require("./projects/atevaldo novo/small/DJI_0053.JPG"),
				29:require("./projects/atevaldo novo/small/DJI_0057.JPG"),
				30:require("./projects/atevaldo novo/small/DJI_0056.JPG"),
				31:require("./projects/atevaldo novo/small/DJI_0073.JPG"),
				32:require("./projects/atevaldo novo/small/DJI_0067.JPG"),
				33:require("./projects/atevaldo novo/small/DJI_0080.JPG"),
				34:require("./projects/atevaldo novo/small/DJI_0058.JPG"),
				35:require("./projects/atevaldo novo/small/DJI_0054.JPG"),
				36:require("./projects/atevaldo novo/small/DJI_0087.JPG"),
				37:require("./projects/atevaldo novo/small/DJI_0078.JPG"),
				38:require("./projects/atevaldo novo/small/DJI_0084.JPG"),
				39:require("./projects/atevaldo novo/small/DJI_0070.JPG"),
				40:require("./projects/atevaldo novo/small/DJI_0055.JPG"),
				41:require("./projects/atevaldo novo/small/DJI_0050.JPG"),
				42:require("./projects/atevaldo novo/small/DJI_0066.JPG"),
				43:require("./projects/atevaldo novo/small/DJI_0088.JPG"),
}
},
	25:{
		meta:require("./projects/glydson/meta.json"),
		images:{
				0:require("./projects/glydson/small/2021110114584944.jpg"),
				1:require("./projects/glydson/small/2021110114570084.jpg"),
				2:require("./projects/glydson/small/2021110114563777.jpg"),
}
},
	26:{
		meta:require("./projects/odair/meta.json"),
		images:{
				0:require("./projects/odair/small/2020040816105671.jpg"),
				1:require("./projects/odair/small/2020040816120441.jpg"),
				2:require("./projects/odair/small/2020040816130482.jpg"),
}
},
	27:{
		meta:require("./projects/selomar/meta.json"),
		images:{
				0:require("./projects/selomar/small/2020050610221422.jpg"),
				1:require("./projects/selomar/small/2020050610205168.jpg"),
				2:require("./projects/selomar/small/2020050612445607.jpg"),
}
},
	28:{
		meta:require("./projects/fazenda elinaldo drone/meta.json"),
		images:{
				0:require("./projects/fazenda elinaldo drone/small/DJI_0538.JPG"),
				1:require("./projects/fazenda elinaldo drone/small/DJI_0596.JPG"),
				2:require("./projects/fazenda elinaldo drone/small/DJI_0609.JPG"),
				3:require("./projects/fazenda elinaldo drone/small/DJI_0558.JPG"),
				4:require("./projects/fazenda elinaldo drone/small/DJI_0564.JPG"),
				5:require("./projects/fazenda elinaldo drone/small/DJI_0574.JPG"),
				6:require("./projects/fazenda elinaldo drone/small/IMG_20220817_075314.jpg"),
				7:require("./projects/fazenda elinaldo drone/small/DJI_0576.JPG"),
				8:require("./projects/fazenda elinaldo drone/small/IMG_20220817_074818.jpg"),
				9:require("./projects/fazenda elinaldo drone/small/DJI_0548.JPG"),
				10:require("./projects/fazenda elinaldo drone/small/DJI_0581.JPG"),
				11:require("./projects/fazenda elinaldo drone/small/IMG_20220817_074639.jpg"),
				12:require("./projects/fazenda elinaldo drone/small/DJI_0555.JPG"),
				13:require("./projects/fazenda elinaldo drone/small/DJI_0578.JPG"),
}
},
	29:{
		meta:require("./projects/paula dias/meta.json"),
		images:{
				0:require("./projects/paula dias/small/DJI_0180.JPG"),
				1:require("./projects/paula dias/small/DJI_0178.JPG"),
				2:require("./projects/paula dias/small/DJI_0188.JPG"),
}
},
	30:{
		meta:require("./projects/renato ala/meta.json"),
		images:{
				0:require("./projects/renato ala/small/DJI_0296.JPG"),
				1:require("./projects/renato ala/small/DJI_0315.JPG"),
				2:require("./projects/renato ala/small/DJI_0311.JPG"),
}
},
	31:{
		meta:require("./projects/ellen/meta.json"),
		images:{
				0:require("./projects/ellen/small/2020020617501476.jpg"),
				1:require("./projects/ellen/small/2020020617485543.jpg"),
}
},
	32:{
		meta:require("./projects/natal de jesus/meta.json"),
		images:{
				0:require("./projects/natal de jesus/small/2022040713410730.jpg"),
				1:require("./projects/natal de jesus/small/2022040713422779.jpg"),
				2:require("./projects/natal de jesus/small/2022040713413594.jpg"),
}
},
	33:{
		meta:require("./projects/roberto valadao/meta.json"),
		images:{
				0:require("./projects/roberto valadao/small/DJI_0210.jpg"),
				1:require("./projects/roberto valadao/small/DJI_0209.jpg"),
				2:require("./projects/roberto valadao/small/DJI_0212.jpg"),
				3:require("./projects/roberto valadao/small/DJI_0206.jpg"),
				4:require("./projects/roberto valadao/small/DJI_0207.jpg"),
				5:require("./projects/roberto valadao/small/DJI_0228.jpg"),
				6:require("./projects/roberto valadao/small/DJI_0208.jpg"),
				7:require("./projects/roberto valadao/small/DJI_0204.jpg"),
				8:require("./projects/roberto valadao/small/DJI_0229.jpg"),
				9:require("./projects/roberto valadao/small/DJI_0216.jpg"),
				10:require("./projects/roberto valadao/small/DJI_0222.jpg"),
				11:require("./projects/roberto valadao/small/DJI_0211.jpg"),
				12:require("./projects/roberto valadao/small/DJI_0217.jpg"),
				13:require("./projects/roberto valadao/small/DJI_0220.jpg"),
				14:require("./projects/roberto valadao/small/DJI_0221.jpg"),
				15:require("./projects/roberto valadao/small/DJI_0215.jpg"),
				16:require("./projects/roberto valadao/small/DJI_0226.jpg"),
				17:require("./projects/roberto valadao/small/DJI_0224.jpg"),
				18:require("./projects/roberto valadao/small/DJI_0218.jpg"),
				19:require("./projects/roberto valadao/small/DJI_0219.jpg"),
				20:require("./projects/roberto valadao/small/DJI_0223.jpg"),
				21:require("./projects/roberto valadao/small/DJI_0227.jpg"),
				22:require("./projects/roberto valadao/small/DJI_0214.jpg"),
				23:require("./projects/roberto valadao/small/DJI_0213.jpg"),
				24:require("./projects/roberto valadao/small/DJI_0225.jpg"),
}
},
	34:{
		meta:require("./projects/portobello shop/meta.json"),
		images:{
				0:require("./projects/portobello shop/small/DJI_0166.JPG"),
				1:require("./projects/portobello shop/small/DJI_0161.JPG"),
				2:require("./projects/portobello shop/small/DJI_0168.JPG"),
}
},
	35:{
		meta:require("./projects/marcus craveiro/meta.json"),
		images:{
				0:require("./projects/marcus craveiro/small/2021120613093995.jpg"),
				1:require("./projects/marcus craveiro/small/2021120613082123.jpg"),
				2:require("./projects/marcus craveiro/small/2021120613102286.jpg"),
}
},
	36:{
		meta:require("./projects/sun light/meta.json"),
		images:{
				0:require("./projects/sun light/small/2020010815403065.jpg"),
				1:require("./projects/sun light/small/2020010812584855.jpg"),
}
},
	37:{
		meta:require("./projects/mercatto/meta.json"),
		images:{
				0:require("./projects/mercatto/small/2020031617493860.jpg"),
				1:require("./projects/mercatto/small/2020031617474065.jpg"),
				2:require("./projects/mercatto/small/2020031617451718.jpg"),
				3:require("./projects/mercatto/small/2020031717153751.jpg"),
}
},
	38:{
		meta:require("./projects/fernando viandelli/meta.json"),
		images:{
				0:require("./projects/fernando viandelli/small/DJI_0035.JPG"),
				1:require("./projects/fernando viandelli/small/DJI_0019.JPG"),
				2:require("./projects/fernando viandelli/small/DJI_0033.JPG"),
}
},
	39:{
		meta:require("./projects/juraci/meta.json"),
		images:{
				0:require("./projects/juraci/small/DJI_0005.JPG"),
				1:require("./projects/juraci/small/DJI_0013.JPG"),
				2:require("./projects/juraci/small/DJI_0999.JPG"),
				3:require("./projects/juraci/small/DJI_0009.JPG"),
				4:require("./projects/juraci/small/DJI_0003.JPG"),
				5:require("./projects/juraci/small/DJI_0012.JPG"),
				6:require("./projects/juraci/small/DJI_0008.JPG"),
				7:require("./projects/juraci/small/DJI_0993.JPG"),
				8:require("./projects/juraci/small/DJI_0992.JPG"),
				9:require("./projects/juraci/small/DJI_0998.JPG"),
				10:require("./projects/juraci/small/DJI_0997.JPG"),
				11:require("./projects/juraci/small/DJI_0989.JPG"),
				12:require("./projects/juraci/small/DJI_0007.JPG"),
				13:require("./projects/juraci/small/DJI_0002.JPG"),
				14:require("./projects/juraci/small/DJI_0994.JPG"),
				15:require("./projects/juraci/small/DJI_0996.JPG"),
				16:require("./projects/juraci/small/DJI_0011.JPG"),
				17:require("./projects/juraci/small/DJI_0004.JPG"),
				18:require("./projects/juraci/small/DJI_0991.JPG"),
				19:require("./projects/juraci/small/DJI_0010.JPG"),
				20:require("./projects/juraci/small/DJI_0001.JPG"),
				21:require("./projects/juraci/small/DJI_0995.JPG"),
				22:require("./projects/juraci/small/DJI_0990.JPG"),
				23:require("./projects/juraci/small/DJI_0006.JPG"),
}
},
	40:{
		meta:require("./projects/bruno porto/meta.json"),
		images:{
				0:require("./projects/bruno porto/small/DJI_0809.JPG"),
				1:require("./projects/bruno porto/small/DJI_0824.JPG"),
				2:require("./projects/bruno porto/small/DJI_0807.JPG"),
				3:require("./projects/bruno porto/small/DJI_0821.JPG"),
				4:require("./projects/bruno porto/small/DJI_0820.JPG"),
				5:require("./projects/bruno porto/small/DJI_0817.JPG"),
				6:require("./projects/bruno porto/small/DJI_0819.JPG"),
				7:require("./projects/bruno porto/small/DJI_0806.JPG"),
				8:require("./projects/bruno porto/small/DJI_0804.JPG"),
				9:require("./projects/bruno porto/small/DJI_0823.JPG"),
				10:require("./projects/bruno porto/small/DJI_0816.JPG"),
				11:require("./projects/bruno porto/small/DJI_0811.JPG"),
				12:require("./projects/bruno porto/small/DJI_0813.JPG"),
				13:require("./projects/bruno porto/small/DJI_0808.JPG"),
				14:require("./projects/bruno porto/small/DJI_0814.JPG"),
				15:require("./projects/bruno porto/small/DJI_0803.JPG"),
				16:require("./projects/bruno porto/small/DJI_0822.JPG"),
				17:require("./projects/bruno porto/small/DJI_0818.JPG"),
				18:require("./projects/bruno porto/small/DJI_0812.JPG"),
				19:require("./projects/bruno porto/small/DJI_0815.JPG"),
				20:require("./projects/bruno porto/small/DJI_0810.JPG"),
				21:require("./projects/bruno porto/small/DJI_0805.JPG"),
}
},
	41:{
		meta:require("./projects/francisco moecy/meta.json"),
		images:{
				0:require("./projects/francisco moecy/small/DJI_0205.JPG"),
				1:require("./projects/francisco moecy/small/DJI_0210.JPG"),
				2:require("./projects/francisco moecy/small/DJI_0206.JPG"),
}
},
	42:{
		meta:require("./projects/goias bombas/meta.json"),
		images:{
				0:require("./projects/goias bombas/small/IMG_20221019_164918.jpg"),
				1:require("./projects/goias bombas/small/IMG_20221019_164929.jpg"),
				2:require("./projects/goias bombas/small/IMG_20221019_164926.jpg"),
				3:require("./projects/goias bombas/small/IMG_20221019_164915.jpg"),
				4:require("./projects/goias bombas/small/IMG_20221019_165035.jpg"),
				5:require("./projects/goias bombas/small/IMG_20221019_165022.jpg"),
				6:require("./projects/goias bombas/small/IMG_20221019_165028.jpg"),
}
},
	43:{
		meta:require("./projects/gilberto/meta.json"),
		images:{
				0:require("./projects/gilberto/small/DJI_0020.JPG"),
				1:require("./projects/gilberto/small/DJI_0035.JPG"),
				2:require("./projects/gilberto/small/DJI_0026.JPG"),
				3:require("./projects/gilberto/small/DJI_0042.JPG"),
				4:require("./projects/gilberto/small/DJI_0039.JPG"),
				5:require("./projects/gilberto/small/DJI_0036.JPG"),
				6:require("./projects/gilberto/small/DJI_0027.JPG"),
				7:require("./projects/gilberto/small/DJI_0016.JPG"),
				8:require("./projects/gilberto/small/DJI_0034.JPG"),
				9:require("./projects/gilberto/small/DJI_0038.JPG"),
				10:require("./projects/gilberto/small/DJI_0019.JPG"),
				11:require("./projects/gilberto/small/DJI_0047.JPG"),
				12:require("./projects/gilberto/small/DJI_0021.JPG"),
				13:require("./projects/gilberto/small/DJI_0023.JPG"),
				14:require("./projects/gilberto/small/DJI_0045.JPG"),
				15:require("./projects/gilberto/small/DJI_0033.JPG"),
				16:require("./projects/gilberto/small/DJI_0040.JPG"),
				17:require("./projects/gilberto/small/DJI_0029.JPG"),
				18:require("./projects/gilberto/small/DJI_0037.JPG"),
				19:require("./projects/gilberto/small/DJI_0041.JPG"),
				20:require("./projects/gilberto/small/DJI_0017.JPG"),
				21:require("./projects/gilberto/small/DJI_0030.JPG"),
				22:require("./projects/gilberto/small/DJI_0044.JPG"),
				23:require("./projects/gilberto/small/DJI_0032.JPG"),
				24:require("./projects/gilberto/small/DJI_0046.JPG"),
				25:require("./projects/gilberto/small/DJI_0048.JPG"),
				26:require("./projects/gilberto/small/DJI_0024.JPG"),
				27:require("./projects/gilberto/small/DJI_0028.JPG"),
				28:require("./projects/gilberto/small/DJI_0043.JPG"),
				29:require("./projects/gilberto/small/DJI_0018.JPG"),
				30:require("./projects/gilberto/small/DJI_0031.JPG"),
				31:require("./projects/gilberto/small/DJI_0025.JPG"),
				32:require("./projects/gilberto/small/DJI_0022.JPG"),
}
},
	44:{
		meta:require("./projects/rede 78/meta.json"),
		images:{
				0:require("./projects/rede 78/small/DJI_0772.JPG"),
				1:require("./projects/rede 78/small/DJI_0774.JPG"),
				2:require("./projects/rede 78/small/DJI_0760.JPG"),
				3:require("./projects/rede 78/small/DJI_0762.JPG"),
				4:require("./projects/rede 78/small/DJI_0777.JPG"),
				5:require("./projects/rede 78/small/DJI_0759.JPG"),
				6:require("./projects/rede 78/small/DJI_0768.JPG"),
				7:require("./projects/rede 78/small/DJI_0765.JPG"),
				8:require("./projects/rede 78/small/DJI_0771.JPG"),
				9:require("./projects/rede 78/small/DJI_0766.JPG"),
				10:require("./projects/rede 78/small/DJI_0775.JPG"),
				11:require("./projects/rede 78/small/DJI_0779.JPG"),
				12:require("./projects/rede 78/small/DJI_0758.JPG"),
				13:require("./projects/rede 78/small/DJI_0767.JPG"),
				14:require("./projects/rede 78/small/DJI_0770.JPG"),
				15:require("./projects/rede 78/small/DJI_0769.JPG"),
				16:require("./projects/rede 78/small/DJI_0776.JPG"),
				17:require("./projects/rede 78/small/DJI_0778.JPG"),
				18:require("./projects/rede 78/small/DJI_0764.JPG"),
				19:require("./projects/rede 78/small/DJI_0773.JPG"),
				20:require("./projects/rede 78/small/DJI_0763.JPG"),
				21:require("./projects/rede 78/small/DJI_0761.JPG"),
}
},
	45:{
		meta:require("./projects/homero/meta.json"),
		images:{
				0:require("./projects/homero/small/2020082013365957.jpg"),
				1:require("./projects/homero/small/2020082013393437.jpg"),
				2:require("./projects/homero/small/2020082013383163.jpg"),
}
},
	46:{
		meta:require("./projects/claudia moya/meta.json"),
		images:{
				0:require("./projects/claudia moya/small/DJI_0245.JPG"),
				1:require("./projects/claudia moya/small/DJI_0258.JPG"),
				2:require("./projects/claudia moya/small/DJI_0248.JPG"),
}
},
}
export {data}